export const ORGANIZATION_SEARCH_QUERY = 'ORGANIZATION_SEARCH_QUERY';
export const ORGANIZATION_SEARCH_RECEIVE = 'ORGANIZATION_SEARCH_RECEIVE';
export const ORGANIZATION_SEARCH_SHOW_FULL_FORM = 'ORGANIZATION_SEARCH_SHOW_FULL_FORM';
export const ORGANIZATION_SEARCH_SELECT_ITEM = 'ORGANIZATION_SEARCH_SELECT_ITEM';
export const ORGANIZATION_SEARCH_TOGGLE_AUTOCOMPLETE = 'ORGANIZATION_SEARCH_TOGGLE_AUTOCOMPLETE';
export const ORGANIZATION_SET_ORG_LIST = 'ORGANIZATION_SET_ORG_LIST';
export const ORGANIZATION_SEARCH_ERROR = 'ORGANIZATION_SEARCH_ERROR';
export const ORGANIZATION_PERSON_INFO = 'ORGANIZATION_PERSON_INFO';

export const ORGANIZATION_LOAD = 'ORGANIZATION_LOAD';
export const ORGANIZATION_ERROR = 'ORGANIZATION_ERROR';